"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/BannerSliderComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BannerSlideItem_1 = __importDefault(require("../BannerSliderComponent/BannerSlideItem"));
var BannerSliderComponent = /** @class */ (function (_super) {
    __extends(BannerSliderComponent, _super);
    function BannerSliderComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BannerSliderComponent.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { id: "bannerSlider_" + this.props.UniqueKey, className: "carousel slide", "data-ride": "carousel" },
            react_1.default.createElement("ol", { className: "carousel-indicators" }, this.props.Slides.map(function (item, i) {
                return react_1.default.createElement("li", { key: i, "data-target": "#bannerSlider_" + _this.props.UniqueKey, "data-slide-to": i, className: item.IsActive ? 'active' : '' });
            })),
            react_1.default.createElement("div", { className: "carousel-inner" }, this.props.Slides.map(function (item, i) {
                return react_1.default.createElement(BannerSlideItem_1.default, { key: item.UniqueKey, UniqueKey: item.UniqueKey, ParentUniqueKey: item.ParentUniqueKey, Header: item.Header, Description: item.Description, ImageUrl: item.ImageUrl, IsActive: item.IsActive, LinkTitle: item.LinkTitle, LinkUrl: item.LinkUrl });
            })),
            react_1.default.createElement("a", { className: "carousel-control-prev", href: "#bannerSlider_" + this.props.UniqueKey, role: "button", "data-slide": "prev" },
                react_1.default.createElement("span", { className: "carousel-control-prev-icon", "aria-hidden": "true" }),
                react_1.default.createElement("span", { className: "sr-only" }, "Previous")),
            react_1.default.createElement("a", { className: "carousel-control-next", href: "#bannerSlider_" + this.props.UniqueKey, role: "button", "data-slide": "next" },
                react_1.default.createElement("span", { className: "carousel-control-next-icon", "aria-hidden": "true" }),
                react_1.default.createElement("span", { className: "sr-only" }, "Next"))));
    };
    return BannerSliderComponent;
}(react_1.default.Component));
exports.default = BannerSliderComponent;
